import { formatDate } from "@angular/common";
import { BillableMoovDataDTO } from "../DTO/billableMoovDataDTO";

export class BillableMoovData {
    public id!: number;
    public customerId!: number;
    public status!: number;
    public moovDefinitionName!: string;
    public moovDefinitionId!: number;
    public moovConfigurationId!: number;
    public sourceMoovFileId!: number;
    public sourceFilename!: string;
    public sourceRecordCount!: number;
    public resultMoovFieldId!: number;
    public resultFilename!: string;
    public resultRecordCount!: number;
    public added!: Date;
    public completedAt!: Date;
    public dateMonth!: string;
    public dateDay!: string;

    public static mapFromDTO(param: BillableMoovDataDTO): BillableMoovData {
        if (!param) throw new Error("param is null");
        let obj = new BillableMoovData();
        try {
            obj.id = param.id;
            obj.customerId = param.customerId;
            obj.status = param.status;
            obj.moovDefinitionName = param.moovDefinitionName;
            obj.moovDefinitionId = param.moovDefinitionId;
            obj.moovConfigurationId = param.moovConfigurationId;
            obj.sourceMoovFileId = param.sourceMoovFileId;
            obj.sourceFilename = param.sourceFilename;
            obj.sourceRecordCount = param.sourceRecordCount;
            obj.resultMoovFieldId = param.resultMoovFieldId;
            obj.resultFilename = param.resultFilename;
            obj.resultRecordCount = param.resultRecordCount;
            obj.added = new Date(param.added);
            obj.completedAt = new Date(param.completedAt);
            obj.dateMonth = formatDate(param.completedAt, 'MM-01-yyyy', 'en-US');
            obj.dateDay = formatDate(param.completedAt, 'MM-dd-yyyy', 'en-US');
        }
        catch (e) {
            console.log(e);
        }
        return obj;
    }

    public static mapToDTO(param: BillableMoovData): BillableMoovDataDTO {
        if (!param) throw new Error("parameter is null")
        let dto = new BillableMoovDataDTO();
        try {
            dto.id = param.id;
            dto.customerId = param.customerId;
            dto.status = param.status;
            dto.moovDefinitionName = param.moovDefinitionName;
            dto.moovDefinitionId = param.moovDefinitionId;
            dto.moovConfigurationId = param.moovConfigurationId;
            dto.sourceMoovFileId = param.sourceMoovFileId;
            dto.sourceFilename = param.sourceFilename;
            dto.sourceRecordCount = param.sourceRecordCount;
            dto.resultMoovFieldId = param.resultMoovFieldId;
            dto.resultFilename = param.resultFilename;
            dto.resultRecordCount = param.resultRecordCount;
            dto.added = param.added.toISOString();
            dto.completedAt = param.completedAt.toISOString();
        }
        catch (e) {
            console.log(e);
        }
        return dto;
    }

    get formatDateMonth(): string {
        return this.dateDay;
    }

    get formatDateDay():string{
        return this.dateMonth;
    }   
}